import styled, { css } from 'styled-components';
import colors from 'constants/colors';
import Back from 'components/Back';

import icCloseBlack from '../../../assets/icons/ic_close_black.svg';

export const CloseIcon = styled.div`
  width: 32px;
  height: 32px;
  position: absolute;
  top: 32px;
  background: url(${icCloseBlack});
  right: 32px;
  margin: 15px 15px 0 0;
  cursor: pointer;

  // Level with the title so it clears the stepper on narrow screens
  @media (max-width: 768px) {
    top: 26px;
    right: 26px;
    margin: 0;
  }
`;

export const ModalContainer = styled.div`
  background-color: #fff;
  width: calc(100vw - 32px);
  padding: 64px;
  max-width: 640px;
  max-height: calc(100vh - 64px);
  overflow-y: auto;

  @media (max-width: 768px) {
    width: 100%;
    padding: 32px;
  }
`;

export const FieldWrapper = styled.div`
  margin-bottom: 24px;
`;

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const inputStyles = css`
  width: 100%;
  padding: 10px 0;
  border: none;
  border-top: 1px solid ${colors.main.dividers};
  border-bottom: 1px solid ${colors.main.dividers};
  outline: none;
  font-family: inherit;
  font-size: 16px;
  font-weight: 400;
  color: ${colors.main.black};
  background: none;

  &::placeholder {
    color: ${colors.main.placeholdersAndDisabledBtnsText};
    opacity: 1; /* Firefox */
  }
`;

export const TextInput = styled.input`
  ${inputStyles}
`;

export const TypeaheadWrapper = styled.div`
  position: relative;
`;

export const SuggestionsList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  max-height: 208px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid ${colors.main.dividers};
  border-radius: 0 0 8px 8px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
`;

interface SuggestionItemProps {
  highlighted?: boolean;
}

export const SuggestionItem = styled.button<SuggestionItemProps>`
  display: block;
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: ${({ highlighted }) => (highlighted ? colors.main.secondaryBtns : 'none')};
  font-family: inherit;
  font-size: 16px;
  font-weight: 400;
  color: ${colors.main.black};
  text-align: left;
  cursor: pointer;

  &:hover {
    background: ${colors.main.secondaryBtns};
  }
`;

export const SuggestionHint = styled.span`
  margin-left: 8px;
  font-size: 12px;
  color: ${colors.main.placeholdersAndDisabledBtnsText};
  text-transform: uppercase;
`;

export const ImageRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ImagePreview = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: cover;
  background: ${colors.main.dividers};
`;

export const ImageActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const ImageButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.main.blue};
  cursor: pointer;
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

// In-flow rather than the Ponder page's fixed mobile bar, which would sit under the modal.
export const StepActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid ${colors.main.dividers};
`;

export const StepBack = styled(Back)`
  align-items: center;
  color: ${colors.main.black};
  display: flex;
  font-size: 14px;
  font-weight: 500;
  gap: 8px;
  letter-spacing: 0.04em;
  margin-right: auto;

  &:hover {
    color: ${colors.main.blue};

    path {
      fill: ${colors.main.blue} !important;
    }
  }
`;
